<template>
   <ob-modal2 width="790px" height="473px" v-if="showComposeMailpopup" :show.sync="showComposeMailpopup" :type="1" :backdrop="false">
    <div class="row fixed-height">
        <div class="col-md-12 fixed-height">
            <div class="row fixed-height">
                <div class="col-md-12 fixed-height">
                    <div class="compose-mail-container">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="compose-mail-heading">
                                    <p style="font-size: 14px;font-weight: 600;">Share {{ timesheetLabel }} ({{getDateRange()}})</p>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <div class="to-address-div clearfix">
                                    <label>To</label>
                                    <div class="to-adddress-select">
                                        <ob-select2  :options="options" v-model="mail.toAddress" :multiple="true"></ob-select2>
                                    </div>
                                    <div class="right-cc-div" v-if="!CCSection || !BCCSection">
                                        <label @click="showCC" v-if="!CCSection">Cc</label>
                                        <label @click="showBCC" v-if="!BCCSection">Bcc</label>
                                    </div>
                                    <span class="ob-vuelidate_error-msg compose-mail__error" v-if="$v.mail.toAddress.$dirty && !$v.mail.toAddress.required"> Please enter To Address</span>
                                </div>
                            </div>
                        </div>
                        <div class="row" v-if="CCSection">
                            <div class="col-md-12">
                                <div class="cc-address-div clearfix">
                                    <label>Cc</label>
                                    <div class="to-adddress-select">
                                        <ob-select2 :inModal="true" :options="options" v-model="mail.ccAddress" :multiple="true"></ob-select2>
                                    </div>
                                    <a href="javascript:;" class="cc-close-icon" @click="showCC">X</a>
                                    <span class="ob-vuelidate_error-msg compose-mail__error" v-if="$v.mail.ccAddress.$dirty && !$v.mail.ccAddress.requiredIf"> Please enter Cc Address</span>
                                </div>
                            </div>
                        </div>
                        <div class="row" v-if="BCCSection">
                            <div class="col-md-12">
                                <div class="bcc-address-div clearfix">
                                    <label>Bcc</label>
                                    <div class="to-adddress-select">
                                        <ob-select2 :inModal="true" :options="options" v-model="mail.bccAddress" :multiple="true"></ob-select2>
                                    </div>
                                    <a href="javascript:;" class="cc-close-icon" @click="showBCC">X</a>
                                    <span class="ob-vuelidate_error-msg compose-mail__error" v-if="$v.mail.bccAddress.$dirty && !$v.mail.bccAddress.requiredIf"> Please enter Bcc Address</span>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                 <div class="subject-div clearfix">
                                    <label>Subject</label>
                                    <input type="text" class="subject-input" v-model="mail.subject">
                                    <span class="email__subject ob-vuelidate_error-msg" v-if="$v.mail.subject.$dirty && !$v.mail.subject.required"> Please enter subject</span>
                                </div>
                            </div>
                        </div>
                        <div class="row" v-if="showComposeMailpopup">
                            <div class="col-md-12"  :class="{ 'ob-vuelidate_input-error': !IsValid}">
                                  <tinymce  :inputData="inputDate" :height="230+'px'" className="body_content" :toolbar-required="true" :auto-resize="false"  @textareaInput="DescriptionInput"></tinymce>
                            </div>
                           <div class="col-md-12" style="margin:10px">
                                <template v-for="(item,index) in ShareSelectedTimesheet" v-if="getReport(item) != null && getReport(item) != '' && getReport(item) != undefined">
                                    <div class="attachments-view">
                                        <template>
                                            <span>
                                               <!-- {{item.TimesheetReportUrl | I9URL2FileName}} -->
                                                {{getReportTitle(item.DateRange)}}
                                            </span>
                                            <ob-popover trigger="click" :options="{placement: 'bottom'}">
                                                <div class="popper" style="padding:0px">
                                                    <div style="padding:10px;">
                                                        <span :class="{'cursorCls': !isFileType(getReport(item))}" >
                                                            <span :class="{'hideShow': !isFileType(getReport(item))}" style="display:inline-block;padding-right:10px;cursor:pointer"><img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/vue/I-9/print_icon.jpg`" width="32" height="32" @click="printSingleDoc(getReport(item))" /></span>
                                                            <span class="tooltiptext">This document cannot be printed as browser doesn't support printing of documents in few formats (doc/ docx/ xls/ xlsx/ zip)</span>
                                                        </span>
                                                        <span style="display:inline-block;padding:0 5px;cursor:pointer"><img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/vue/I-9/download_icon.jpg`" width="31" height="32" @click="downloadSingleDoc(getReport(item))" /></span>
                                                        <span style="display:inline-block;padding-left:10px;cursor:pointer"><img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/vue/I-9/view_icon.jpg`" width="32" height="32" @click="previewSingleDoc(getReport(item))" /></span>
                                                    </div>
                                                </div>
                                                <img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/vue/I-9/blue-pill.png`" width="15" height="15" slot="reference" style="cursor:pointer;display:inline-block;margin-left:10px" />
                                            </ob-popover>
                                        </template>
                                    </div>
                                </template>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <div class="mail-footer-div" style="text-align: center !important;">
                                    <ob-button type="secondary" @click="discardMail">Cancel</ob-button>
                                    <ob-button type="primary" @click="sendMail">Send</ob-button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    </ob-modal2>
</template>
<script>
    import { required, email, numeric, url, requiredIf } from 'vuelidate/lib/validators'
    import c from 'Vue/Core/constants.js'
    import jquery from 'jquery'
    import utils from "Vue/Core/utils.js";
    import tinymce from "@/Components/tinymce.vue";

    import CommonFunctionMixin from './CommonFunctionMixin.js'

    export default {
        props: ["show","ShareSelectedTimesheet","ShareReportType","SelectedMonth"],
        mixins: [CommonFunctionMixin],
        data(){
            return{
                inputDate: '',
                IsValid:true,
                Id:'',
                showComposeMailpopup:false,
                CCSection:false,
                BCCSection: false,
                options: {
                    ajax: {
                        type: 'PUT',
                        url: function (params) {
                            return `${c.APIBASEURL}/Email/ComposeMailSuggestions?email=${params.term}`
                        },
                        delay: 250,
                        data: function (params) {
                            var query = {

                            }

                            return query;
                        },
                        headers: {
                            'Authorization': `Bearer ${localStorage.getItem('access_token')}`
                        },
                        processResults: function (data) {
                            try {
                                data = JSON.parse(data);
                            } catch(ex) {

                            }
                            let results = []
                            if (data !== null) {
                                data.forEach((e) => {
                                    results.push({
                                        id: e.Email,
                                        text: e.Email
                                    })
                                })
                            }

                            return {
                                results: results
                            };
                        }
                    },
                    placeholder: '',
                    tags: true,
                    selectOnClose: true,
                    tokenSeparators: [',', ' '],
                    minimumInputLength: 3,
                    createTag: function (params) {
                        var expr = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                        var term = jquery.trim(params.term)
                        if (expr.test(term) == true) {
                            return {
                                id: term,
                                text: term
                            };
                        }
                        else
                            return null;
                    }
                },
                mail: {
                    name:'',
                    toAddress: '',
                    ccAddress: [],
                    bccAddress: [],
                    subject: '',
                    bodyContent:'',
                    attachments:[]
                },
                Description:'',
                tinyMceId: 'editor_' + __.random(10000, 99999),


            }
        },
        validations() {
            return{
                mail: {
                    toAddress: {
                        required
                    },
                    ccAddress: {
                        requiredIf: requiredIf(() => {
                            return this.CCSection
                        })
                    },
                    bccAddress: {
                        requiredIf: requiredIf(() => {
                            return this.BCCSection
                        })
                    },
                    subject: {
                        required
                    }
                }
            }
        },
        mounted() {
            this.tinymcePlugin();
        },
        components: {
            "tinymce": tinymce,
        },
        computed: {
            ManualRemainderEmpList()
            {
                return this.$store.getters.getManualRemainderEmpIds;
            },
            empName()
            {
               var empName = this.ManualRemainderEmpList.map(v=>v.name)

               let empString = empName.join("; ");

               if(empName.length > 20)
               {
                 let count = empName.length - 20;
                 empString +=  ` `+count+` More`
               }
               return empString
            },
            loggedInUserName() {
                return this.loggedInUserObj.Name ? this.loggedInUserObj.Name : this.loggedInUserObj.name ? this.loggedInUserObj.name : '';
            },
            subject()
            {
               return `${this.timesheetLabel} from ${this.getDateRange()}`;
            }
        },
        watch: {
               show(val)
               {
                    this.$loading({'loadingText': 'Loading...'});
                    this.showComposeMailpopup = val;
                    this.resetData();
                    this.bodyContentText();
                    setTimeout(() => {
                        this.$loading({}).close();
                    }, 350)
               },
               mailDetails(val)
               {
                 this.Id = "",
                 this.mail.toAddress = "",
                 this.mail.name = "",
                 this.mail.attachments.push("")
               },
               showComposeMailpopup(val)
               {
                    this.$emit('update:show', val)
               },
               Description(val) {
                    if(val != null && val != "")
                    {
                        this.IsValid = true
                    }
                    else{
                         this.IsValid = false
                    }
                    Vue.set(this.mail, 'bodyContent', val)
               }
        },
        created() {

        },
        methods:{
            getReport(item)
            {
                if(this.ShareReportType.OnblickTimesheetReport && this.ShareReportType.ExpenseReport)
                {
                     return item.ReportUrl;
                }
                else if(this.ShareReportType.OnblickTimesheetReport && !this.ShareReportType.ExpenseReport)
                {
                    return item.TimesheetReportUrl;
                }
                else if(!this.ShareReportType.OnblickTimesheetReport && this.ShareReportType.ExpenseReport)
                {
                    return item.ExpenseReportUrl;
                }
            },
            getReportTitle(timesheetDateRange)
            {
                if(this.ShareReportType.OnblickTimesheetReport &&  this.ShareReportType.ExpenseReport)
                {
                    return this.empName+"_"+timesheetDateRange+"_TimesheetExpense.pdf"
                }
                if(this.ShareReportType.OnblickTimesheetReport &&  !this.ShareReportType.ExpenseReport)
                {
                    return this.empName+"_"+timesheetDateRange+`_${this.timesheetLabel}.pdf`
                }
                if(!this.ShareReportType.OnblickTimesheetReport &&  this.ShareReportType.ExpenseReport)
                {
                    return this.empName+"_"+timesheetDateRange+"_Expense.pdf"
                }
            },
            isFileType(item)
            {
                var filename = utils.I9URL2FileName(item);
                var fileExtention = filename.split('.').pop();
                var FileTypes = ["pdf", "png", "gif", "jpg", "jpeg"];
                return FileTypes.includes(fileExtention)
            },
            getDateRange()
            {
               var dateRangeList = this.ShareSelectedTimesheet.map(v=>v.DateRange);
               var totalDateList = [];
               for(var i = 0 ; i < dateRangeList.length ; i++)
               {
                  let dateRange =  dateRangeList[i].split(' to ');
                  totalDateList = totalDateList.concat(dateRange);
               }
               var minDate = totalDateList.reduce(function (a, b) { return moment(a) < moment(b) ? a : b; });
               var maxDate = totalDateList.reduce(function (a, b) { return moment(a) > moment(b) ? a : b; });

               return `${minDate} to ${maxDate}`
            },
            bodyContentText()
            {
                this.inputDate = ` Dear User,<br>
                                    Greetings for the day! We are delighted to inform you that the ${this.timesheetLabel} for the period
                                    ranging ${this.getDateRange()} are now available.`
                // var mailBody = '<div>' ;
                // for(var i = 0 ; i< this.ShareSelectedTimesheet.length ; i++ )
                // {
                //     let data = this.ShareSelectedTimesheet[i] ;
                //     mailBody += `<div>${i+1}. ${data.DateRange} &emsp;     ${data.ProjectTitle != null && data.ProjectTitle != ''  ? data.ProjectTitle : 'N/A'}    &emsp;  ${data.ClientOrganizationName != null && data.ClientOrganizationName != '' ? data.ClientOrganizationName : 'N/A'}     &emsp;   ${data.TotalHours}</div>`;
                // }
                // mailBody += '</div>';

               // this.inputDate = 'Hi,'+ mailBody;
            },
            DescriptionInput(val)
            {
                if(val != null && val != "")
                {
                    this.IsValid = true
                }
                else{
                        this.IsValid = false
                }
                Vue.set(this.mail, 'bodyContent', val)
            },
            showCC(){
                this.CCSection = !this.CCSection
            },
            showBCC(){
                this.BCCSection = !this.BCCSection
            },
            discardMail() {
                    this.showComposeMailpopup = false
                    window.bus.fire("UnselectEmployees");
                    this.resetData();
             },
            sendMail() {
                     this.$v.mail.$touch()

                    var tmp = document.createElement("DIV");
                    tmp.innerHTML = this.mail.bodyContent;
                    var tempBody = tmp.textContent || tmp.innerText || "";
                    var trimmedBody = tempBody.trim();
                    if(this.mail.bodyContent != null && this.mail.bodyContent != "" && trimmedBody != null && trimmedBody != '')
                    {
                        this.IsValid = true
                    }
                    else{
                         this.IsValid = false
                    }

                    var attachments = [];

                    if(this.ShareReportType.OnblickTimesheetReport && this.ShareReportType.ExpenseReport)
                    {
                        attachments = this.ShareSelectedTimesheet.map(v=>v.ReportUrl);
                    }
                    else if(this.ShareReportType.OnblickTimesheetReport && !this.ShareReportType.ExpenseReport)
                    {
                        attachments = this.ShareSelectedTimesheet.map(v=>v.TimesheetReportUrl);
                    }
                    else if(!this.ShareReportType.OnblickTimesheetReport && this.ShareReportType.ExpenseReport)
                    {
                        attachments = this.ShareSelectedTimesheet.map(v=>v.ExpenseReportUrl);
                    }

                    attachments = attachments.filter(v=> v != null && v != '' && v != undefined)

                    if (this.$v.mail.$invalid != true && this.IsValid) {


                          var params = {
                                "SelectedTimesheetIds":  this.ShareSelectedTimesheet.map(v=>v.Id),
                                "shareMailIds": this.mail.toAddress,
                                "CC": this.mail.ccAddress,
                                "BCC": this.mail.bccAddress,
                                "MailBody":`<h2 class="" style="margin-top: 216px;font-weight:600;font-size:21px;color:#233854;">
																	${this.timesheetLabel} Available for the Month (${this.SelectedMonth})
															</h2>` + this.mail.bodyContent,
                                "Subject":this.mail.subject,
                                "AttachementUrls": attachments,
                                "EmployeeId":''
                                }
                     this.$loading({ 'loadingText': 'Sending...' })
                    ajax.put(`/TimeSheets/ShareTimesheetReport`, params, (res) => {
                        if (res.data.State == true) {

                              setTimeout(() => {
                                    this.$loading({}).close()
                                    this.$message({
                                        type: 'success',
                                        message: 'Mail has been sent successfully!'
                                    })
                                    this.UpdateTimesheetCalender();
                                    this.resetData()
                                    this.showComposeMailpopup = false;
                              }, 6000);


                            // window.bus.fire("refreshCalender");
                        } else {
                            this.resetData()
                            this.showComposeMailpopup = false;
                            this.$loading({}).close()
                            this.$message({
                                type: 'error',
                                message: res.data.Message
                            })
                        }

                    })
             }
            },
            UpdateTimesheetCalender()
            {
                var empId = this.ManualRemainderEmpList[0].id;

                let cList = this.$store.getters.getTimesheetCustomMonthlyList;
                let empIndex = cList.findIndex(c => c.EmployeeId == empId);
                var shareLog =
                {
                    SharedTo : this.mail.toAddress,
                    SharedDateTime : moment().format('MM/DD/YYYY h:mm a'),
                }

                if (empIndex != -1) {

                    var selectedTimesheets = this.ShareSelectedTimesheet.map(v=>v.Id);
                    var employee = cList[empIndex];

                    for(var m = 0 ; m < selectedTimesheets.length ; m++)
                    {

                         let eventIndex = employee.CalendarList.findIndex(e => e.Id == selectedTimesheets[m]);

                         if (eventIndex != -1) {
                                var event = employee.CalendarList[eventIndex];

                                event.TimesheetSharedLogModel = event.TimesheetSharedLogModel.concat(shareLog);
                                cList[empIndex].CalendarList[eventIndex] = event;
                                this.$store.commit("updateTimesheetCustomMonthlyList", cList);
                         }
                    }
                }
                window.bus.fire("UnselectEmployees");
            },
             resetData() {
                this.$v.mail.$reset(),
                this.CCSection = false;
                this.BCCSection = false;
                this.mail.toAddress = '';
                this.mail.ccAddress = [];
                this.mail.bccAddress = [];
                this.mail.attachments = [];
                this.mail.subject = this.subject;
                this.mail.bodyContent = '';
                this.Description = '';
            },
            tinymcePlugin() {
                var vm = this
                tinymce.init({
                    selector: "#" + vm.tinyMceId,
                    plugins: "autoresize",
                    menubar: false,
                    height: 250,
                    max_height:250,
                    paste_data_images: true,
                    image_dimensions: true,
                    statusbar: false, //to hide status bar
                    plugins: [
                        'advlist autolink lists link image charmap print preview hr anchor pagebreak',
                        'textcolor colorpicker',
                        'searchreplace wordcount visualblocks visualchars code fullscreen',
                        'insertdatetime media nonbreaking save table contextmenu directionality',
                        'emoticons template paste textcolor colorpicker textpattern'
                    ],
                    setup: function (ed) {
                        ed.on('init', function () {
                            this.getDoc().body.style.fontSize = '14px';
                            this.getDoc().body.style.fontFamily = 'Open Sans';
                            //vm.mail.bodyContent = ed.getContent()
                        });
                        ed.on('change', function () {
                            vm.mail.bodyContent = ed.getContent();
                            ed.save();
                        });
                        ed.on('blur', function () {
                            vm.mail.bodyContent = ed.getContent();
                        });
                    },
                    toolbar1: ' bold | italic | underline | alignleft aligncenter alignright alignjustify | bullist numlist | forecolor backcolor | fontselect | fontsizeselect | link image',
                    style_formats: [
                        { title: 'Line height 20px', selector: 'p,div,h1,h2,h3,h4,h5,h6', styles: { lineHeight: '20px', padding: '0px' } },
                        { title: 'Line height 30px', selector: 'p,div,h1,h2,h3,h4,h5,h6', styles: { lineHeight: '30px', padding: '3px' } }
                    ],
                    fontsize_formats: '8px 10px 12px 14px 18px',
                    font_formats: "Arial=arial,helvetica,sans-serif;" +
                    "Georgia=georgia,palatino;" +
                    "Helvetica=helvetica;" +
                    "Tahoma=tahoma,arial,helvetica,sans-serif;" +
                    "Verdana=verdana,geneva;" +
                    "Times New Roman=times new roman,times;" + "Open Sans=Open Sans, sans-serif;",
                    image_advtab: true,
                    file_picker_callback: function (callback, value, meta) {
                        if (meta.filetype == 'image') {
                            $('#upload').trigger('click');
                            $('#upload').on('change', function () {
                                var file = this.files[0];
                                var reader = new FileReader();
                                reader.onload = function (e) {
                                    callback(e.target.result, {
                                        alt: ''
                                    });
                                };
                                reader.readAsDataURL(file);
                            });
                        }
                    }
                });
            },
        }
    }
</script>
<style lang='scss' scoped>
@import "~styles/framework/vue-utils";
.fixed-height{
    height: 100%;
}
.compose-mail-container{
     height: auto;
    background-color: #fff;
    box-shadow: -1px 0px 14px -5px rgba(0,0,0,0.64);
    .compose-mail-heading{
       // background-color: $ob-brand-primary;
        p{
            margin: 0;
            padding: 15px 20px;
            color : $ob-brand-primary;
            font-size: 11px;
            font-weight: 600;
        }
    }
    .to-address-div{
        border-top: 1px solid #c2c2c2;

        border-bottom: 1px solid #c2c2c2;
        padding: 10px 20px;

        color: #000;
        font-size: 12px;
        font-weight: 600;

        label{
            color: #030303;
            font-size: 11px;
            font-weight: 600;
            margin-bottom: 0;
            width:50px;
            display:inline-block;
        }
        .to-adddress-select{
            width:80%;
            display:inline-block;
        }
        .right-cc-div{
            display:inline-block;
            label{
                display: inline-block;
                font-size: 11px;
                font-weight: 600;
                margin:0 0 0 5px;
                cursor: pointer;
                width:auto;
            }
        }
    }
    .cc-close-icon{
        float: right;
        display:inline-block;
        font-size: 12px;
        font-weight: 600;
        color:#030303;
    }
    .cc-address-div{
        @extend .to-address-div
    }
    .bcc-address-div{
        @extend .to-address-div
    }
    .subject-div{
        @extend .to-address-div;
        color: #000;
        font-size: 12px;
        font-weight: 600;
        label{
            margin: 10px 0 0 0;
        }
        .subject-input{
            width:90%;
            padding: 10px;
            border: 0;
        }
    }
    .mail-signature-div{
        @extend .to-address-div
    }
    .mail-body-content{

    }
    .mail-footer-div{
        padding: 10px 20px;
        background-color: #f4f4f4;
    }
    .file-attachment-container{
        padding:10px 5px;
    }
    .mail-details__signature {
        position: absolute;
        background-color: #fff;
        z-index: 1;
        width: 176px;
        top: 49px;
        left: 37px;
        box-shadow: 0 2px 4px 0 rgba(0,0,0,.2);
        border-radius: 4px;
        border: 1px solid #e5e5e5;
        &:before, &:after{
            bottom: 100%;
            right: 14%;
            border: solid transparent;
            content: " ";
            height: 0;
            width: 0;
            position: absolute;
            pointer-events: none;
        }
        &:before{
                border-color: transparent;
                border-bottom-color: #e5e5e5;
                border-width: 10px;
                margin-left: -13px;
        }
        &:after {
                border-color: hsla(0,0%,100%,0);
                border-bottom-color: #fff;
                border-width: 9px;
                margin-left: -12px;
        }
        ul{
            list-style-type:none;
            padding: 0;
            li{
                font-size: 12px;
                padding: 10px;
                color:#848484;
                font-weight:600;
                cursor:pointer;
                text-align:left;
                border-bottom:1px solid #eee;
                &:last-child{
                                border:none;
                            }
                .address{
                    width: 65px;
                    display: inline-block;
                }
                &:hover{
                    background:#f0f0f0;
                }
                &.active{
                    background:#f0f0f0;
                }
            }
        }
    }
    .compose-mail__error{
        padding-left:50px;
    }
      .attachments-view
        {
            font-size: 12px;
            margin-bottom: 5px;
            // color:#4A90E2;
            margin-left: 0px;
            border: 1px solid #4A90E2 !important;
            background: #e6eff9  !important;
            padding: 5px 10px;
            display: inline-block;
            border-radius: 30px;
            font-weight: 600;
            float: left;
            margin-right: 2%;
        }
          .cursorCls{
      cursor:not-allowed !important;
      position: relative;
      display: inline-block;
    }
    .cursorCls .tooltiptext {
      visibility: hidden;
      width: 500px;
      background-color: #fff;
      color: #143361;
      box-shadow: 0 -1px 20px #ccc;
      z-index: 99999;
      text-align: center;
      border-radius: 6px;
      padding: 5px 0;

      /* Position the tooltip */
      position: absolute;
      top: 100%;
      left: 50%;
      margin-left: -60px;
      z-index: 1;
    }
    .cursorCls:hover .tooltiptext {
      visibility: visible;
       display: inline;
    }
    .cursorCls .tooltiptext::after {
     content: "";
      position: absolute;
      bottom: 100%;
      left: 11%;
      margin-left: -5px;
      border-width: 5px;
      border-style: solid;
      border-color: transparent  transparent #fff transparent;
    }
    .tooltiptext{
      display: none
    }
    .hideShow
    {
        pointer-events: none !important;
    }
}
</style>
<style>
    .compose-mail-container .mail-body-content .mce-btn-group .mce-btn button{
        padding: 4px 5px;
    }
    .compose-mail-container .mail-body-content .mce-listbox .mce-caret{
        right: 0 !important;
    }
    .compose-mail-container .mail-body-content .mce-panel{
        border-bottom-width: 0px !important;
        border-right-width: 0px !important;
        border-left-width: 0px !important;
    }
    .to-adddress-select .select2-container--onblick .select2-selection.select2-selection--multiple{
        border: 0 !important;
    }
    .compose-mail-container .ob-vuelidate_error-msg {
        font-size: 12px;
        display:block;
    }

    .compose-mail-container .email__subject {
        padding-left: 50px;
    }
    .compose-mail-container .mail-details__signature ul li.active p {
        background: #f0f0f0;
    }


</style>



// WEBPACK FOOTER //
// src/components/ESSProfile/Timesheets/ShareTimesheetsMailPopu.vue